import { useState, useEffect, createRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { Button, Loading } from 'carbon-components-react';
import { isEmpty } from 'lodash';
// Components
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper';
import SubHeader from '../../components/SubHeader/SubHeader';
import DetailOverview from './DetailSections/DetailOverview';
import DetailDates from './DetailSections/DetailDates';
import DetailManual from './DetailSections/DetailManual';
import DetailConneX from './DetailSections/DetailConneX';
import ConfirmModal from '../../components/Modal/ConfirmModal';
// import DetailAttachment from './DetailSections/DetailAttachment';
// import DetailRegistry from './DetailSections/DetailRegistry';
// import DetailLocation from './DetailSections/DetailLocation';
// hooks
import useRegistriesGrid from '../Registries/useRegistriesGrid'
import useAttachmentsGrid from '../Attachments/useAttachmentsGrid'
import useLocationsGrid from '../Locations/useLocationsGrid'
import useLinksGrid from '../StudyLink/useLinksGrid';
// api/data
import useStudyData from '../../helpers/useStudyData';

const StudyDetails = () => {

  // study data
  const {
    // CURRENT DATA
    studyDetails,
    setStudyDetails,
    getFieldValue,
    // SET DATA
    dataToSubmit,
    setDataToSubmit,
    dirtyFields,
    // reducer action types
    INIT_STUDY,
    SET_OVERRIDE_DATA,
    SET_SPONSOR_DATA,
    SET_RELATED_STUDIES,
    SET_COMMERCIAL_PRODUCTS,
    SET_DEVELOPMENT_STATUS,
    // SAVE DATA
    submitData,
    submitConneXData,
    submitManualData,
    submitBooleanField,
    fieldStatuses,
    //SYNC DATA
    syncStudy,
  } = useStudyData((() => {
    // study ID
    const url = window.location.href.split("/")
    return url[url.length - 1]
  })())

  const [studyId, setStudyId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openSyncModal, setOpenSyncModal] = useState(false);
  const [connexRefs, setConnexRefs] = useState([])
  const [ctgDataMenuIsOpen, setCtgDataMenuIsOpen] = useState(false)

  // registries
  const {
    addRegistryButton,
    registriesGrid,
  } = useRegistriesGrid({
    isStudyDetail: true,
    studyRegistry: studyDetails?.study_registries,
    setStudyDetails,
    studyPgId: studyId,
    studyOrgStudyId: studyDetails?.org_study_id
  })

  // attachments
  const {
    addAttachmentsButton,
    attachmentGrid,
  } = useAttachmentsGrid({
    isStudyDetail: true,
    attachmentList: studyDetails?.attachments,
    setStudyDetails,
    studyPgId: studyId,
    studyOrgStudyId: studyDetails?.org_study_id
  })

  // locations
  const {
    locationsGrid,
    addLocationButton,
    locationsLoading,
  } = useLocationsGrid({
    isStudyDetail: true,
    studyLocation: studyDetails?.locations,
    setStudyDetails,
    studyPgId: studyId,
     studyOrgStudyId: studyDetails?.org_study_id
  })

  const {
    linkGrid,
    addLinksButton,
    linksLoading,
  } = useLinksGrid({
    isStudyDetail: true,
    linkList: studyDetails?.links,
    setStudyDetails,
    studyPgId: studyId,
     studyOrgStudyId: studyDetails?.org_study_id
  })

  const { client, id } = useParams();

  let sectionRefs = [];
  for (let i = 0; i < 7; i++) {
    sectionRefs.push(createRef());
  }

  useEffect(() => {
    if (studyDetails) {
      setStudyId(parseInt(studyDetails.id))
    }
  }, [studyDetails])

  const confirmSync = () => {
    setOpenSyncModal(false);
    setLoading(true);
    syncStudy().then(() => {
      setLoading(false);
    });
  };
  const scrollToSection = (index) => {
    if (index < sectionRefs.length) {
      sectionRefs[index].current.scrollIntoView({ behavior: 'smooth', block: "center" })
    }
  }

  const scrollToConnexTarget = (index) => {
    if (index < connexRefs?.length) {
      if (connexRefs?.[index]?.current?.scrollIntoView) connexRefs[index].current.scrollIntoView({ behavior: 'smooth', block: "center" });
    }
  }

  const onOverviewSubmit = (id, value) => {
    // includes non-boolean org_study_id
    submitBooleanField(id, value)

    // for actual booleans,
    // ... user already updates app state
    // but for org_study_id, need to update app state
    if (id === 'org_study_id') {
      setStudyDetails({ type: INIT_STUDY, data: { ...studyDetails, [id]: value } })
    }
  }

  const btnStyle = {
    padding: "5px 10px",
    height: "30px",
    minHeight: "30px",
    width: "fit-content",
  };


  /** RENDERERS */

  const saveManualDataBtn = () => {
    return <Button
      kind="primary"
      onClick={submitManualData}
      style={btnStyle}
      disabled={
        !dirtyFields ||
        (
          (!dirtyFields.sponsor_data ||
            isEmpty(dirtyFields.sponsor_data)) &&
          !dirtyFields.related_studies &&
          !dirtyFields.commercial_products &&
          !dirtyFields.development_status &&
          !dirtyFields.logo
        )
      }
    >Save Manual Data</Button>
  }

  const saveOverrideDataBtn = () => {
    return <Button
      kind="primary"
      onClick={submitConneXData}
      style={btnStyle}
      disabled={!dirtyFields || !dirtyFields.override || isEmpty(dirtyFields.override)}
    >Save Override Data</Button>
  }

  const onCtgDataMenuClick = () => {
    scrollToSection(2)
    setCtgDataMenuIsOpen(!ctgDataMenuIsOpen)
  }

  const onCtgDataItemClick = (index) => {
    scrollToConnexTarget(index)
    setCtgDataMenuIsOpen(false)
  }

  if (!studyDetails) {
    return <Loading />
  }

  return (
    <Container>
      <ContentContainer>
        {
          loading ?
            <Loading
            />
            :
            <></>
        }
        <StudyDetailsHeaderContainer>
          {/* <SubHeader
            title={studyDetails.org_study_id}
            // subtitle="Sponsor Trial Website Management"
            size="lg"
          /> */}
          <Link to={`/${client}/studies`} style={{color: 'black'}}>
          <SubHeading>
            <i style={{color : 'rgb(237, 18, 1)'}} className="fas fa-chevron-left"></i>
            <BackTo>
                Back to All Studies
            </BackTo>
          </SubHeading>
          </Link>
          <Header>
            <SectionHeading>
            <div>Org Study ID: {studyDetails?.org_study_id}</div>
            </SectionHeading>
          </Header>
          <HeaderBar>
            <Link to={`/${client}`}>
              <HeaderLink >Dashboard</HeaderLink>
            </Link>
            <HeaderLink onClick={() => scrollToSection(0)}>Overview</HeaderLink>
            <HeaderLink onClick={() => scrollToSection(1)}>Manual Data</HeaderLink>
            <HeaderLink onClick={() => scrollToSection(6)}>Logos/Buttons</HeaderLink>
            <HeaderLink>
              <div
                onClick={onCtgDataMenuClick}
                onMouseOver={() => setCtgDataMenuIsOpen(true)}
              >
                CTG Data
              </div>
              <CtgDataSubMenuStyled
                isOpen={ctgDataMenuIsOpen}
                onMouseOver={() => setCtgDataMenuIsOpen(true)}
                onMouseOut={() => setCtgDataMenuIsOpen(false)}
              >
                <ul>
                  <li onClick={() => onCtgDataItemClick(0)}>Trial Overview</li>
                  <li onClick={() => onCtgDataItemClick(1)}>Trial at a Glance</li>
                  <li onClick={() => onCtgDataItemClick(2)}>Key Requirements</li>
                  <li onClick={() => onCtgDataItemClick(3)}>Trial Details</li>
                  <li onClick={() => onCtgDataItemClick(4)}>Trial Results</li>
                </ul>
              </CtgDataSubMenuStyled>
            </HeaderLink>
            <HeaderLink onClick={() => scrollToSection(3)}>Registries</HeaderLink>
            <HeaderLink onClick={() => scrollToSection(4)}>Attachments</HeaderLink>
            <HeaderLink onClick={() => scrollToSection(5)}>Locations</HeaderLink>

            {/* <Button
              kind="secondary"
              onClick={() => setOpenSyncModal(true)}
              style={btnStyle}
            >Regenerate CTG Data</Button> */}
            <Button
              kind="primary"
              onClick={(evt) => submitData()}
              style={btnStyle}
              disabled={!dirtyFields || isEmpty(dirtyFields)}
            >Save Data</Button>
          </HeaderBar>

        </StudyDetailsHeaderContainer>

        <StudyDetailsContentContainer>

          <SectionWrapper ref={sectionRefs[0]}>
            <SectionHeader>
              <SectionHeading>Overview</SectionHeading>
            </SectionHeader>
            <SectionContent>
              <DetailOverview
                data={studyDetails}
                submit={onOverviewSubmit}
              />
            </SectionContent>
          </SectionWrapper>

          <SectionWrapper>
            <SectionHeader>
              <SectionHeading>Study Dates</SectionHeading>
            </SectionHeader>
            <SectionContent>
              <DetailDates studyDetails={studyDetails}></DetailDates>
            </SectionContent>
          </SectionWrapper>

          <SectionWrapper
            ref={sectionRefs[1]}
            className="clearfix"
          >
            <SectionHeaderWithButton>
              <div>
                <SectionHeading>Manually Entered Data</SectionHeading>
                <SectionText>Study data that is manually entered and not pulled from CTG. For manually entered location fields, go to the locations section.</SectionText>
              </div>
              <SectionButton>
                {saveManualDataBtn()}
              </SectionButton>
            </SectionHeaderWithButton>
            <SectionContent>
              <DetailManual
                data={studyDetails}
                dirtyFields={dirtyFields}
                dataToSubmit={dataToSubmit}
                setDataToSubmit={setDataToSubmit}
                SET_SPONSOR_DATA={SET_SPONSOR_DATA}
                SET_RELATED_STUDIES={SET_RELATED_STUDIES}
                SET_DEVELOPMENT_STATUS={SET_DEVELOPMENT_STATUS}
                SET_COMMERCIAL_PRODUCTS={SET_COMMERCIAL_PRODUCTS}
                fieldStatuses={fieldStatuses}
              ></DetailManual>
            </SectionContent>
            <SectionContent>
            </SectionContent>
            <SectionBottomButton>
              {saveManualDataBtn()}
            </SectionBottomButton>
          </SectionWrapper>
          <SectionWrapper ref={sectionRefs[6]}>
            <SectionHeaderWithButton>
              <SectionHeading>Logos/Buttons</SectionHeading>
              <SectionButton>
                {addLinksButton()}
              </SectionButton>
            </SectionHeaderWithButton>
            <SectionGridContent>
              {linkGrid()}
            </SectionGridContent>
          </SectionWrapper>
          <SectionWrapper className="clearfix">
            <SectionHeaderWithButton
              ref={sectionRefs[2]}
            >
              <div>
                <SectionHeading>ConneX Data</SectionHeading>
                <SectionText>Study data that pulled from CTG through ConneX. To override a field enter values into the override column</SectionText>
              </div>
              <SectionButton>
                {saveOverrideDataBtn()}
              </SectionButton>
            </SectionHeaderWithButton>
            <DetailConneX
              data={studyDetails}
              refs={connexRefs}
              setRefs={setConnexRefs}
              getFieldValue={getFieldValue}
              dirtyFields={dirtyFields}
              dataToSubmit={dataToSubmit}
              setDataToSubmit={setDataToSubmit}
              SET_OVERRIDE_DATA={SET_OVERRIDE_DATA}
            />
            <SectionBottomButton>
              {saveOverrideDataBtn()}
            </SectionBottomButton>
          </SectionWrapper>

          <SectionWrapper ref={sectionRefs[3]}>
            <SectionHeaderWithButton>
              <SectionHeading>Registries</SectionHeading>
              <SectionButton>
                {addRegistryButton()}
              </SectionButton>
            </SectionHeaderWithButton>
            <SectionGridContent>
              {registriesGrid()}
            </SectionGridContent>
          </SectionWrapper>

          <SectionWrapper ref={sectionRefs[4]}>
            <SectionHeaderWithButton>
              <SectionHeading>Attachments</SectionHeading>
              <SectionButton>
                {addAttachmentsButton()}
              </SectionButton>
            </SectionHeaderWithButton>
            <SectionGridContent>
              {attachmentGrid()}
            </SectionGridContent>
          </SectionWrapper>

          <SectionWrapper ref={sectionRefs[5]}>
            <SectionHeaderWithButton>
              <SectionHeading>Locations</SectionHeading>
              <SectionButton>
                {addLocationButton()}
              </SectionButton>
            </SectionHeaderWithButton>
            <SectionGridContent>
              {locationsGrid()}
            </SectionGridContent>
          </SectionWrapper>

          {/* <SectionWrapper ref={sectionRefs[5]}>
            <SectionContent>
              <StudyDetailsFooter>
                <Button
                  kind="primary"
                  onClick={saveStudyDetails}
                  style={btnStyle}
                >Save Changes</Button>
              </StudyDetailsFooter>
            </SectionContent>
          </SectionWrapper> */}

        </StudyDetailsContentContainer>
        <ConfirmModal
          title="Regenerate CTG Data"
          content={`Do you want to regenerate CTG study data for ${studyDetails?.org_study_id}?`}
          open={openSyncModal}
          onClose={() => setOpenSyncModal(false)}
          onConfirm={() => confirmSync()}
        />
      </ContentContainer>
    </Container>
  );
};

export default StudyDetails;

/**
 * Basic Styles
 */

 const StudyDetailsHeaderContainer = styled.div`
 width: 100%;
 max-width: 1200px;
 flex: 0 1 auto;
 padding-top: 4em;
`
const StudyDetailsContentContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  // overflow-y: scroll;
  padding-top: 90px;
`
const SubHeading = styled.div`
  width: 97%;
  display: flex;
  border-radius: 7px;
  position: fixed;
  top: 56px;
  padding-top: 10px;
  height:10%;
  z-index: 999;
  background-color: rgb(245, 246, 250);
`
const Header = styled.div`
  width: 97%;
  display: flex;
  border-radius: 7px;
  position: fixed;
  top: 80px;
  padding-top: 10px;
  height:10%;
  z-index: 999;
  background-color: rgb(245, 246, 250);
`
const BackTo = styled.div`
  padding-left: 4px;
  cursor: pointer;
`
const HeaderBar = styled.div`
  width: 100%;
  max-width: 1200px;

  display: flex;
  justify-content: space-around;
  background-color: rgba(39, 39, 39, 0.74);
  border-radius: 7px;
  align-items: center;
  position: fixed;
  top: 120px;
  z-index: 999;

  a:hover {
    text-decoration: none;
  }
`
const HeaderLink = styled.div`
  color: #fff;
  font-size: 15px;
  padding: 15px 0px;
  cursor: pointer;
  position: relative;

  &:hover {
    color: #E5E7EB;
  }
`

const CtgDataSubMenuStyled = styled.div`
  position: absolute;
  white-space: nowrap;
  background-color: #707070;
  padding: 1em;
  padding-bottom: 0.4em;
  margin-top: 15px;
  border-radius: 0 0 3px 3px;
  box-shadow: 0px 2px 5px 0px #8c8c8c;
  display: ${({ isOpen }) => isOpen ? 'block' : 'none'};

  li {
    margin-bottom: 0.8em;

    &:hover {
      color: black;
    }
  }
`

/* Add some top padding to the page content to prevent sudden quick movement (as the navigation bar gets a new position at the top of the page (position:fixed and top:0) */

const SectionWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  margin: 10px 0px;
  padding: 18px;
  background-color: #fff;
  scroll-margin-top: 40px;
`;

const SectionContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
`

const SectionGridContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  min-height: 280px;
`

const SectionHeader = styled.div`
  padding-bottom: 18px;
`

const SectionHeaderWithButton = styled(SectionHeader)`
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    white-space: nowrap;
  }
`

const SectionHeading = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-color: #000000;
  flex: 1;
`

const SectionText = styled.div`
  font-size: 16px;
  line-height: 28px;
  padding-top: 18px;
`

const SectionButton = styled.div`
  margin-left: 1rem;
`

const SectionBottomButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
`

// const StudyDetailsFooter = styled.div`
//   width: 100%;
// `
